import { Component, OnInit } from "@angular/core";
import { AppService } from "../../../app.service";

@Component({
  selector: 'app-achievement',
  templateUrl: './achievement.component.html',
  styleUrls: ['./achievement.component.scss']
})
export class AchievementComponent implements OnInit {
   selectedLanguage = "";

  font = "";
  ContentData: any;
  News_event_data: any;
  foundnews: any;

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    // this.selectedLanguage = localStorage.getItem('selectedLanguage');

    this.FetchData();
  }
    // Test truncate starts
    truncateText(text, maxLength) {
        // Check if the text length is greater than the maximum length
        if (text.length > maxLength) {
            // Truncate the text to the maximum length and append "..." at the end
            return text.substring(0, maxLength) + "...";
        } else {
            // If the text length is within the maximum length, return the original text
            return text;
        }
    }
    
    stripHtml(html: string): string {
        if (!html) return '';
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }

  FetchData() {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "response FetchData");

      this.ContentData = response.data;
      console.log(this.ContentData, "Default Content Data");

      if (this.ContentData != null) {
        let news = this.ContentData.filter(
          (x) => x.ContentCategoryName == "Achievements"
        );
        news.sort((a: any, b: any) => b.Id - a.Id);
        this.News_event_data = news;
        // this.foundnews = this.News_event_data.ShowAttachments;
        console.log(this.News_event_data, "All Achievements Data");
      }
    });
  }

  GetFontName() {
    switch (this.selectedLanguage) {
      case "en":
        return "Congenial";
      case "bn":
        return "Kalpurush";
      case "ar":
        return "Jameel Noori Nastaleeq";
    }
  }

}
